module.exports = __webpack_public_path__ + "static/img/activity_background.d90640f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity_background.png
// module id = mb6v
// module chunks = 128